import React, { useContext, useEffect, useRef, useState } from "react";
import ReactDOMServer from "react-dom/server";
import cx from "classnames";

import global from "../../../scss/dhp.scss";

import { Icon } from "../../ui/icon";
import { Card, CardBody, CardHeader, Col, Row } from "reactstrap";
import { widgetConfig } from "../editor_config";
import useDragAndDrop from "../../../hooks/useDragAndDropV2";
import { Input } from "../../ui/input";
import { useSelector } from "react-redux";
import { useUndoRedo } from "../../../hooks/useUndoRedo";
import Modal from "../../ui/modal";
import { dateConverter, hexToRGB } from "../../../_helpers/utils";
import { TIMELINE } from "../../../constants/editor";
import useAlignment from "../../../hooks/useAlignment";
import useAddWidget from "../../../hooks/useAddWidget";
import useElementInnerHtml from "../../../hooks/useElementInnerHtml";
import { EditorContext } from "../../../containers/editor/EditorLayout";

let style = Object.assign({}, global);

const CanvasHtmlData = ({ canvasConfigData, startEndDateInfo }) => {
  const sectionHeaderStyle = {};
  if (canvasConfigData?.sectionHeaderColor) {
    sectionHeaderStyle.backgroundColor = hexToRGB(canvasConfigData.sectionHeaderColor);
  }
  if (canvasConfigData?.sectionBorderColor) {
    sectionHeaderStyle.borderBottom = `1px solid ${hexToRGB(canvasConfigData.sectionBorderColor)}`;
  }

  const sectionSubHeaderStyle = {};
  if (canvasConfigData?.sectionSubheaderColor) {
    sectionSubHeaderStyle.backgroundColor = hexToRGB(canvasConfigData.sectionSubheaderColor);
  }
  if (canvasConfigData?.sectionBorderColor) {
    sectionSubHeaderStyle.borderBottom = `1px solid ${hexToRGB(canvasConfigData.sectionBorderColor)}`;
  }

  const sectionBodyStyle = {};
  if (canvasConfigData?.sectionBodyColor) {
    sectionBodyStyle.backgroundColor = hexToRGB(canvasConfigData.sectionBodyColor);
  }
  if (canvasConfigData?.sectionBorderColor) {
    sectionBodyStyle.borderBottom = `1px solid ${hexToRGB(canvasConfigData.sectionBorderColor)}`;
  }
  if (canvasConfigData?.sectionBodyContentColor) {
    sectionBodyStyle.color = hexToRGB(canvasConfigData.sectionBodyContentColor);
  }

  const grandTotalBodyStyle = {};
  if (canvasConfigData?.grandTotalBodyColor) {
    grandTotalBodyStyle.backgroundColor = hexToRGB(canvasConfigData.grandTotalBodyColor);
  }
  if (canvasConfigData?.grandTotalBorderColor) {
    grandTotalBodyStyle.border = `1px solid ${hexToRGB(canvasConfigData.grandTotalBorderColor)}`;
  }

  // Content Color section
  const sectionHeaderContentStyle = {};
  if (canvasConfigData?.grandTotalBorderColor) {
    sectionHeaderContentStyle.color = hexToRGB(canvasConfigData.sectionHeaderContentColor);
  }

  const sectionSubheaderContentStyle = {};
  if (canvasConfigData?.grandTotalBorderColor) {
    sectionSubheaderContentStyle.color = hexToRGB(canvasConfigData.sectionSubheaderContentColor);
  }

  const grandTotalBodyContentStyle = {};
  if (canvasConfigData?.grandTotalBorderColor) {
    grandTotalBodyContentStyle.color = hexToRGB(canvasConfigData.grandTotalBodyContentColor);
  }
  return (
    <div
      className={cx(style["w-100"], style["pricingTable_editor"], style["timeLine_editor"])}
      style={canvasConfigData?.["font-family"] ? { fontFamily: canvasConfigData["font-family"] } : {}}>
      {canvasConfigData?.sections?.map((sectionInfo, sectionIdx) => (
        <div
          className={`mb-3 card pricing-table-section section-card-${sectionIdx}`}
          key={sectionIdx}
          style={
            canvasConfigData?.sectionBorderColor ? { border: `1px solid ${canvasConfigData.sectionBorderColor}` } : {}
          }>
          <div
            className={cx(
              style["d-flex"],
              style["justify-content-between"],
              style["align-items-center"],
              style["card-header"]
            )}
            style={sectionHeaderStyle}>
            <div className={cx(style["d-flex"], style["align-items-center"])}>
              <h6 className={cx(style["mb-0"], style["fw-7"])} style={sectionHeaderContentStyle}>
                {sectionInfo.name}
              </h6>
            </div>
            <h6 className={`mb-0 fw-7 d-flex pricing-amount `} style={sectionHeaderContentStyle}>
              <div className={"section-total"}>
                {dateConverter(startEndDateInfo?.sections[sectionIdx].minStartDate, "MMM DD, YYYY", "toString")} –{" "}
                {dateConverter(startEndDateInfo?.sections[sectionIdx].maxEndDate, "MMM DD, YYYY", "toString")}
              </div>
            </h6>
          </div>
          <div className={cx(style["p-0"], style["card-body"])}>
            <div className={cx(style["item-label"])} style={sectionSubHeaderStyle}>
              <ul className={cx(style["d-flex"], style["align-items-center"])}>
                <li
                  className={cx(style["task-name-lable"], style["flex-grow-1"], style["ml-0"])}
                  style={sectionSubheaderContentStyle}>
                  Task Name
                </li>
                <li className={cx(style["start-date-lable"])} style={sectionSubheaderContentStyle}>
                  Start Date
                </li>
                <li className={cx(style["end-date-lable"])} style={sectionSubheaderContentStyle}>
                  End Date
                </li>
              </ul>
            </div>
            {sectionInfo?.items?.map((itemInfo, itemIdx) => (
              <div className={cx(style["item-details"])} key={itemIdx} style={sectionBodyStyle}>
                <div className={cx(style["item-info"])}>
                  <ul className={cx(style["d-flex"])}>
                    <li className={cx(style["item-info-details"], style["flex-grow-1"])}>
                      <div className={cx(style["d-flex"], style["mb-2"], style["align-items-center"])}>
                        <span className={cx(style["fw-7"], style["item-name"])}>{itemInfo?.data?.task_name}</span>
                      </div>
                      <div>
                        {itemInfo?.data?.description && (
                          <p className={cx(style["mb-1"], style["pre-line-text"])}>{itemInfo.data.description}</p>
                        )}
                      </div>
                    </li>
                    <li className={cx(style["start-date-value"])}>
                      {dateConverter(itemInfo?.data?.start_date, "ddd MMM DD, YYYY", "toString")}
                    </li>
                    <li className={cx(style["end-date-value"])}>
                      {dateConverter(itemInfo?.data?.end_date, "ddd MMM DD, YYYY", "toString")}
                    </li>
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}

      {canvasConfigData?.sections.length > 1 && (
        <div className={"card pricing-table-total"} style={grandTotalBodyStyle}>
          <div
            className={cx(
              style["d-flex"],
              style["justify-content-between"],
              style["align-items-center"],
              style["card-header"]
            )}>
            <h6 className={cx(style["mb-0"], style["fw-7"])} style={grandTotalBodyContentStyle}>
              Overall Timeline
            </h6>
            <h6 className={cx(style["mb-0"], style["fw-7"])} style={grandTotalBodyContentStyle}>
              <div className="grand-subtotal">
                {dateConverter(startEndDateInfo?.overallMinStartDate, "MMM DD, YYYY", "toString")} –{" "}
                {dateConverter(startEndDateInfo?.overallMaxEndDate, "MMM DD, YYYY", "toString")}
              </div>
            </h6>
          </div>
        </div>
      )}
    </div>
  );
};

const AutoResizingTextarea = ({ inputFieldValue, handleBlur, handleChange, slug, sectionIdx, itemIdx, addSectionItem, ...props }) => {
  const [isFocused, setIsFocused] = useState(false);
  const textareaRef = useRef(null);

  // Set initial and max heights
  const defaultHeight = 100;
  const minHeight = 48;
  const maxHeight = 200;

  useEffect(() => {
    if (textareaRef.current) {
      // Reset height to min when not focused
      if (!isFocused) {
        textareaRef.current.style.height = `${minHeight}px`;
        textareaRef.current.style.minHeight = `${minHeight}px`;
        textareaRef.current.scrollTop = 0; // Ensure scroll is at top
      } else {
        // Set to default height when focused, then allow auto-grow
        textareaRef.current.style.height = `${defaultHeight}px`;
        adjustHeight();
      }
    }
  }, [isFocused]);

  const adjustHeight = () => {
    if (textareaRef.current) {
      // Temporarily set to default height to measure scrollHeight accurately
      textareaRef.current.style.height = `${defaultHeight}px`;

      const scrollHeight = textareaRef.current.scrollHeight;
      let newHeight = Math.min(scrollHeight, maxHeight);
      if (newHeight < maxHeight) newHeight = newHeight + 5;
      // Apply the new height
      textareaRef.current.style.height = `${newHeight < defaultHeight ? defaultHeight : newHeight}px`;
    }
  };

  const handleFocus = () => {
    setIsFocused(true);
  };

  const handleLocalBlur = (e) => {
    if (textareaRef.current) {
      textareaRef.current.scrollTop = 0; // Scroll to top on blur
    }

    setIsFocused(false);
    if (handleBlur) {
      handleBlur(slug, sectionIdx, itemIdx);
    }

    const rawNext = e.relatedTarget;
    const nextEl = rawNext instanceof HTMLElement ? rawNext : null;
    const addTaskEl = nextEl?.closest?.('[data-role="add-task"]');

    const addSectionEl  = nextEl?.closest?.('[data-role="add-section"]');

    if (addTaskEl) addSectionItem("item", sectionIdx);
    if (addSectionEl) addSectionItem("section");
  };

  const handleLocalChange = e => {
    adjustHeight();
    if (handleChange) {
      handleChange(e);
    }
  };

  return (
    <textarea
      ref={textareaRef}
      className={style["form-control"]}
      rows="3"
      value={inputFieldValue || ""}
      onFocus={handleFocus}
      onBlur={handleLocalBlur}
      onChange={handleLocalChange}
      style={{
        height: `${minHeight}px`,
        maxHeight: `${maxHeight}px`,
      }}
      {...props}
    />
  );
};

const ItemFields = ({
  itemValue,
  slug,
  sectionIdx,
  itemIdx,
  updateSectionValue,
  updateTableConfig,
  isEnable = true,
  fieldType = "text",
  maxLength,
  dropdownContainer,
  currData,
  maxMinLimt,
  addSectionItem,
  ...props
}) => {
  const inputRef = useRef(null);

  const [inputFieldValue, setInputFieldValue] = useState("");

  const handleChange = e => {
    // Allow changes if:
    // 1. No maxLength is set, OR
    // 2. The new value is shorter (deletion), OR
    // 3. The new value length is within maxLength
    let value = e.target.value;

    // Trim value to maxLength if it exceeds
    if (maxLength && value.length > maxLength) {
      value = value.substring(0, maxLength);
    }

    setInputFieldValue(value);
  };
  const handleBlur = (slug, sectionIdx, itemIdx) => {
    if (itemValue === inputFieldValue) return;
    let appliedValue = inputFieldValue;

    if (typeof sectionIdx === "number" && typeof itemIdx === "number") {
      updateSectionValue({ [slug]: appliedValue }, sectionIdx, itemIdx);
    }
  };

  const updateCalendar = e => {
    if (e == inputFieldValue) return;
    if (typeof sectionIdx === "number" && typeof itemIdx === "number") {
      let insertValue = e;
      if (insertValue != "") insertValue = dateConverter(insertValue, props.dateFormat, "toUnix");
      updateSectionValue({ [slug]: insertValue }, sectionIdx, itemIdx);
      setInputFieldValue(e);
    }
  };

  useEffect(() => {
    if (isEnable) setInputFieldValue(itemValue);
    else setInputFieldValue("");
  }, [itemValue, isEnable]);

  return (
    <>
      {fieldType != "textarea" && (
        <>
          <Input
            type={fieldType}
            {...(fieldType != "date_calendar" && { value: inputFieldValue })}
            {...(fieldType === "date_calendar" && { defaultValue: inputFieldValue })}
            onChange={e => handleChange(e)}
            onBlur={e => handleBlur(slug, sectionIdx, itemIdx)}
            {...(fieldType === "date_calendar" && { updateState: updateCalendar })}
            disabled={!isEnable}
            isEnable={!isEnable}
            innerRef={inputRef}
            {...props}
          />
        </>
      )}
      {fieldType === "textarea" && (
        <AutoResizingTextarea
          inputFieldValue={inputFieldValue}
          slug={slug}
          sectionIdx={sectionIdx}
          itemIdx={itemIdx}
          handleBlur={handleBlur}
          handleChange={handleChange}
          addSectionItem={addSectionItem}
          {...props}
        />
      )}
    </>
  );
};

const SectionComponent = ({
  sectionIdx,
  sectionInfo,
  tableConfigData,
  handleBlur,
  isEditable,
  handleEditClick,
  changeSectionName,
  onKeyDownFn,
  moveSection,
  deleteSectionItem,
  updateSectionValue,
  addSectionItem,
  setTableConfigData,
  dateFormat,
}) => {
  const sectionRef = useRef(null);
  const [sectionItems, setSectionItems] = useState(sectionInfo.items);
  const [readyToUpdate, setReadyToUpdate] = useState(false);

  const { items: dragItems, containerProps, getItemProps } = useDragAndDrop(sectionItems, "vertical", setReadyToUpdate);

  useEffect(() => {
    if (!readyToUpdate) {
      setReadyToUpdate(false);
      return;
    }
    let updatedTable = { ...tableConfigData };
    updatedTable.sections[sectionIdx].items = dragItems;
    setTableConfigData(updatedTable);
    setReadyToUpdate(false);
  }, [dragItems]);

  useEffect(() => {
    if (sectionInfo?.items) {
      setSectionItems(sectionInfo.items);
    }
  }, [sectionInfo?.items]);

  return (
    <Card className={cx(style["mb-3"])} key={sectionIdx}>
      <CardHeader className={cx(style["d-flex"], style["justify-content-between"], style["align-items-center"])}>
        <div className={cx(style["d-flex"], style["align-items-center"], style["pl-2"])}>
          <h6 className={cx(style["mb-0"], style["mr-5"], style["fw-7"], style["edit-title"], style["d-flex"])}>
            <div
              id={`section-Name-${sectionIdx}`}
              contentEditable={isEditable}
              onBlur={e => handleBlur(e, sectionIdx)}
              onInput={e => changeSectionName(e)}
              onKeyDown={e => onKeyDownFn(e)}
              suppressContentEditableWarning={true}
              className={cx({ [style["rename"]]: isEditable })}>
              {sectionInfo.name}
            </div>
            {!isEditable && (
              <a onClick={() => handleEditClick(sectionIdx)}>
                <Icon icon="ui-edit" />
              </a>
            )}
          </h6>
        </div>
        <ul className={cx(style["d-flex"], style["align-items-center"])}>
          <li
            className={cx(style["custom-tooltip"], style["ml-3"], style["d-flex"], style["cursor-pointer"], {
              [style["disable"]]: sectionIdx === 0,
            })}
            onClick={() => moveSection(sectionIdx, "up")}>
            <Icon icon="ui-arrow-up2" />
            <div className={cx(style["custom-tooltip-content"], style["top"])}>Move Up</div>
          </li>
          <li
            className={cx(style["custom-tooltip"], style["ml-1"], style["d-flex"], style["cursor-pointer"], {
              [style["disable"]]: sectionIdx === tableConfigData.sections.length - 1,
            })}
            onClick={() => moveSection(sectionIdx, "down")}>
            <Icon icon="ui-arrow-down2" />
            <div className={cx(style["custom-tooltip-content"], style["top"])}>Move Down</div>
          </li>
          <li
            className={cx(style["custom-tooltip"], style["ml-3"], style["d-flex"], {
              [style["disable"]]: tableConfigData.sections.length < 2,
              [style["cursor-pointer"]]: tableConfigData.sections.length > 1,
            })}
            onClick={() => deleteSectionItem("section", sectionIdx)}>
            <Icon icon="ui-trash" />
            <div className={cx(style["custom-tooltip-content"], style["top"])}>Delete</div>
          </li>
        </ul>
      </CardHeader>
      <CardBody className={cx(style["card-space"])}>
        <div ref={sectionRef} className={cx(style["customScroll"], style["scroll-X"])}>
          <div className={cx(style["item-label"])}>
            <ul className={cx(style["d-flex"])}>
              {tableConfigData.columns?.map((item, idx) => (
                <li key={idx} className={cx(item.className)}>
                  {item.name}
                </li>
              ))}
            </ul>
          </div>
          <div {...containerProps}>
            {dragItems.map((itemInfo, itemIdx) => (
              <div className={cx(style["item-details"])} key={itemIdx} {...getItemProps(itemIdx)}>
                <div className={cx(style["item-info"])}>
                  <Icon icon="ui-drag2" additionalclass={"drag-icon"} />
                  <ul className={cx(style["d-flex"], style["mb-2"], style["align-items-start"])}>
                    {tableConfigData.columns?.map((item, idx) => (
                      <>
                        {item.slug === "task_name" && (
                          <li
                            key={idx}
                            className={cx(item?.inputFieldClass, style["d-flex"], style["align-items-center"])}>
                            <ItemFields
                              fieldType="text"
                              itemValue={itemInfo?.data?.[item.slug]}
                              slug={item.slug}
                              sectionIdx={sectionIdx}
                              itemIdx={itemIdx}
                              updateSectionValue={updateSectionValue}
                              maxLength={60}
                              required={true}
                            />
                          </li>
                        )}

                        {["start_date", "end_date"].includes(item.slug) && (
                          <li
                            key={idx}
                            className={cx(
                              item?.inputFieldClass,
                              style["d-flex"],
                              style["align-items-center"],
                              style["date-field"]
                            )}>
                            <div className={style["custom-date-picker"]}>
                              <ItemFields
                                itemValue={
                                  itemInfo?.data?.[item.slug] !== ""
                                    ? dateConverter(itemInfo?.data?.[item.slug], dateFormat, "toString")
                                    : ""
                                }
                                fieldType={"date_calendar"}
                                dateFormat={dateFormat}
                                slug={item.slug}
                                sectionIdx={sectionIdx}
                                itemIdx={itemIdx}
                                id={`cal-${sectionIdx}-${itemIdx}-${item.slug}`}
                                updateSectionValue={updateSectionValue}
                                required={true}
                                hideOnscroll={true}
                                isDisabled={true}
                                {...(item.slug == "start_date" && {
                                  maxDate:
                                    itemInfo?.data?.["end_date"] !== ""
                                      ? new Date(itemInfo.data["end_date"] * 1000)
                                      : "",
                                })}
                                {...(item.slug == "end_date" && {
                                  minDate:
                                    itemInfo?.data?.["start_date"] !== ""
                                      ? new Date(itemInfo.data["start_date"] * 1000)
                                      : new Date(),
                                })}
                              />
                            </div>
                          </li>
                        )}
                      </>
                    ))}
                    <li
                      className={cx(style["delete-row"], style["ml-3"], {
                        [style["disable"]]: sectionInfo.items.length < 2,
                        [style["cursor-pointer"]]: sectionInfo.items.length > 1,
                      })}
                      onClick={() => deleteSectionItem("item", sectionIdx, itemIdx)}>
                      <span>
                        <Icon icon="ui-trash" />
                      </span>
                    </li>
                  </ul>
                </div>
                {tableConfigData?.showItemCode && itemInfo?.data?.item_code && (
                  <div className={cx(style["item-code"], style["ml-2"], style["mb-2"], style["d-block"])}>
                    <span className={style["fw-6"]}>Item Code:</span> {itemInfo?.data?.item_code}
                  </div>
                )}

                <div className={cx(style["item-description"], style["d-block"], style["pl-0"])}>
                  <div className="form-group">
                    <ItemFields
                      fieldType={"textarea"}
                      itemValue={itemInfo?.data?.description}
                      slug={"description"}
                      sectionIdx={sectionIdx}
                      itemIdx={itemIdx}
                      updateSectionValue={updateSectionValue}
                      placeholder="Description (Max 300 characters)"
                      maxLength={300}
                      addSectionItem={addSectionItem}
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className={cx(style["add-item"])}>
          <div className={cx(style["d-flex"], style["align-items-center"])}>
            <a
              className={cx(style["d-flex"], style["align-items-center"], style["color-33"])}
              tabIndex={0} 
              data-role="add-task" 
              onClick={() => addSectionItem("item", sectionIdx)}>
              <Icon icon="ui-plus" additionalclass={"mr-2"} />
              <span>Task</span>
            </a>
          </div>
        </div>
      </CardBody>
    </Card>
  );
};

const Timeline = ({ closeModal, modalFullScreen, setModalFullScreen, editTable }) => {
  let { metadata, widgets, updateWidgets } = useContext(EditorContext);

  const timelineDefaultData = JSON.parse(JSON.stringify(widgetConfig?.timeline));

  const date_format = useSelector(state => state?.auth?.user?.date_format) ?? "MM-DD-YYYY";

  const [isEditable, setIsEditable] = useState(false);
  const [insertHtmlMode, setInsertHtmlMode] = useState(false);
  const [insertedHtmlData, setInsertedHtmlData] = useState([]);
  const [disableInsert, setDisableInsert] = useState(true);
  const [addWidgetClicked, setAddWidgetClicked] = useState(false);
  const [dataparam, setDataParam] = useState();
  const [assetInnerContent, setAssetInnerContent] = useState();
  const [widgetWidth, setWidgetWidth] = useState();
  const [widgetHeight, setWidgetHeight] = useState();
  const [customCss, setCustomCss] = useState(false);
  const [startEndDateInfo, setStartEndDateInfo] = useState();

  const htmlMode = false;

  const {
    state: tableConfigData,
    updateState: setTableConfigData,
    undo,
    redo,
    canUndo,
    canRedo,
  } = useUndoRedo(editTable ? editTable : timelineDefaultData?.timelineConfig);
  const { postion: getPosition } = useAlignment(addWidgetClicked, widgetWidth, widgetHeight, "middle-center");
  const getNewWidgetObject = useAddWidget(
    addWidgetClicked,
    TIMELINE,
    dataparam,
    getPosition,
    widgetWidth,
    widgetHeight
  );
  useElementInnerHtml(
    addWidgetClicked,
    setAddWidgetClicked,
    TIMELINE,
    assetInnerContent,
    dataparam,
    getNewWidgetObject,
    customCss
  );

  let dateFormat = date_format.replaceAll("-", "/");

  const getModalHeight = () => {
    if (window.innerWidth < 480) return "calc(95vh - 3rem)";
    if (window.innerWidth < 768) return "calc(90vh - 5rem)";
    return "calc(84vh - 10rem)";
  };

  const addSectionItem = (type, sectionIdx) => {
    // Add item/section
    let updatedTable = { ...tableConfigData };
    if (type === "item") {
      updatedTable.sections[sectionIdx].items.push({
        data: {
          task_name: "",
          description: "",
          start_date: "",
          end_date: "",
        },
      });
    } else {
      updatedTable.sections.push({
        name: "Section Name",

        items: [
          {
            data: {
              task_name: "",
              description: "",
              start_date: "",
              end_date: "",
            },
          },
        ],
      });
    }
    setTableConfigData(updatedTable);
  };

  const deleteSectionItem = (type, sectionIdx, itemIdx) => {
    // Addt item/section
    let updatedTable = { ...tableConfigData };
    if (type === "section") {
      if (updatedTable.sections?.length < 2) return;
      updatedTable.sections.splice(sectionIdx, 1);
    } else {
      if (updatedTable.sections[sectionIdx]?.items?.length < 2) return;
      updatedTable.sections[sectionIdx].items.splice(itemIdx, 1);
    }
    // Update table config data
    setTableConfigData(updatedTable);
  };

  const moveSection = (sectionIdx, position, sectionsArray) => {
    // Check if the section can be moved up or down
    if (
      (position === "up" && sectionIdx === 0) || // Cannot move the first section up
      (position === "down" && sectionIdx === tableConfigData.sections.length - 1) // Cannot move the last section down
    ) {
      return; // Exit the function if the move is invalid
    }
    let updatedTable = { ...tableConfigData };

    // Calculate the new index based on the position
    const newIndex = position === "up" ? sectionIdx - 1 : sectionIdx + 1;

    // Swap the sections in the array
    [updatedTable.sections[sectionIdx], updatedTable.sections[newIndex]] = [
      updatedTable.sections[newIndex],
      updatedTable.sections[sectionIdx],
    ];
    setTableConfigData(updatedTable);
  };

  const setFullScreen = () => {
    setModalFullScreen(!modalFullScreen);
  };

  const close = () => {
    closeModal && closeModal();
    if (modalFullScreen) setModalFullScreen(false);
  };

  const handleEditClick = sectionIdx => {
    setIsEditable(!isEditable);

    // Focus and place cursor at end after state update
    setTimeout(() => {
      const editableDiv = document.getElementById(`section-Name-${sectionIdx}`);
      if (editableDiv) {
        editableDiv.focus();
        return;
      }
    }, 0);
  };

  const changeSectionName = e => {
    const maxLength = 40; // Set your desired max length
    if (e.currentTarget.textContent.length > maxLength) {
      e.currentTarget.textContent = e.currentTarget.textContent.substring(0, maxLength);
    }
  };

  const onKeyDownFn = e => {
    const maxLength = 40;
    const currentText = e.currentTarget.textContent;

    // Allow Ctrl+A (Select All), deletions, and navigation keys
    const allowedKeys = [
      "Backspace",
      "Delete",
      "ArrowLeft",
      "ArrowRight",
      "ArrowUp",
      "ArrowDown",
      "Tab",
      "Home",
      "End",
    ];

    // Allow Ctrl+A (keyCode 65 with Ctrl pressed)
    const isCtrlA = (e.ctrlKey || e.metaKey) && e.key === "a";

    // Block input if maxLength reached (unless allowed key)
    if (currentText.length >= maxLength && !allowedKeys.includes(e.key) && !isCtrlA) {
      e.preventDefault();
    }

    // Prevent Enter key (optional)
    if (e.key === "Enter") {
      e.preventDefault();
      e.currentTarget.blur(); // Optionally blur on Enter
    }
  };

  const handleBlur = (e, sectionIdx) => {
    let updatedTable = { ...tableConfigData };
    setIsEditable(!isEditable);

    if (e.target.textContent.length === 0) {
      e.target.textContent = updatedTable.sections[sectionIdx].name; // Revert to previous value
      return;
    }

    updatedTable.sections[sectionIdx].name = e.target.textContent;
    setTableConfigData(updatedTable);
  };

  const updateSectionValue = (updates, sectionIdx, itemIdx) => {
    if (typeof sectionIdx !== "number" || typeof itemIdx !== "number") return;

    let updatedTable = { ...tableConfigData };
    const section = updatedTable.sections[sectionIdx];
    const item = section.items[itemIdx];

    Object.entries(updates).forEach(([slug, value]) => {
      if (item.data[slug] !== value) {
        item.data[slug] = value;
      }
    });
    setTableConfigData(updatedTable);
  };

  const doUndo = () => {
    undo();
  };
  const doRedo = () => {
    redo();
  };

  const processSectionsData = sections => {
    if (!sections || !Array.isArray(sections)) return sections;

    // Process each section
    const processedSections = sections.map(section => {
      if (!section.items || !Array.isArray(section.items)) return section;

      // Get all start dates and end dates from items in this section
      const startDates = [];
      const endDates = [];
      section.items.forEach(item => {
        if (item.data && item.data.start_date) {
          startDates.push(item.data.start_date);
        }
        if (item.data && item.data.end_date) {
          endDates.push(item.data.end_date);
        }
      });
      // Calculate min start date and max end date for this section
      const minStartDate = startDates.length > 0 ? Math.min(...startDates) : null;
      const maxEndDate = endDates.length > 0 ? Math.max(...endDates) : null;

      // Add the new keys to the section
      return {
        minStartDate,
        maxEndDate,
      };
    });

    // Calculate overall min start date and max end date across all sections
    const allStartDates = [];
    const allEndDates = [];

    processedSections.forEach(section => {
      if (section.minStartDate !== null) {
        allStartDates.push(section.minStartDate);
      }
      if (section.maxEndDate !== null) {
        allEndDates.push(section.maxEndDate);
      }
    });

    const overallMinStartDate = allStartDates.length > 0 ? Math.min(...allStartDates) : null;
    const overallMaxEndDate = allEndDates.length > 0 ? Math.max(...allEndDates) : null;

    // Add overall dates to the main array
    return {
      sections: processedSections,
      overallMinStartDate,
      overallMaxEndDate,
    };
  };

  const insertTable = () => {
    let insertedTableData = { ...tableConfigData };

    setInsertedHtmlData({ ...insertedTableData });
    if (htmlMode) setInsertHtmlMode(true);

    // Use this htmlString for insert
    if (!editTable) {
      const htmlString = ReactDOMServer.renderToString(
        <CanvasHtmlData canvasConfigData={insertedTableData} startEndDateInfo={startEndDateInfo} />
      );
      const elem = document.createElement("div");
      elem.innerHTML = htmlString;

      // add pheudo elem in editor
      const parent = document.getElementById(metadata.activeBlockId);
      const pheudoElem = document.createElement("div");
      pheudoElem.id = "pheudoElem";
      pheudoElem.style.width = "700px";
      pheudoElem.innerHTML = htmlString;
      parent.appendChild(pheudoElem);

      // insert into editor
      setTimeout(() => {
        const jsonString = JSON.stringify(insertedTableData);
        let paramObj = { "data-table-config": jsonString };
        let dataAttr = { ...widgetConfig[TIMELINE].dataAttr, ...paramObj };
        let offsetHeight = document.querySelector("#pheudoElem .timeLine_editor")?.offsetHeight;
        let offsetWidth = 700;
        let scale = 1242 / offsetWidth; // 1242 is page width(which is static)

        document.querySelector("#pheudoElem").remove();

        setCustomCss({
          transform: `scale(${scale})`,
          width: `${offsetWidth}px`,
          height: `${offsetHeight}px`,
        }); // set width height to inner div
        setWidgetWidth(offsetWidth * scale); // set width  to main div
        setWidgetHeight(offsetHeight * scale); // set height to main div
        setAssetInnerContent(elem);
        setDataParam(dataAttr);
        setAddWidgetClicked(true);
      }, 50);
    }
    // update
    else {
      const jsonString = JSON.stringify(insertedTableData);
      const htmlString = ReactDOMServer.renderToString(
        <CanvasHtmlData canvasConfigData={insertedTableData} startEndDateInfo={startEndDateInfo} />
      );
      const elem = document.createElement("div");
      elem.innerHTML = htmlString;
      document.querySelector(`#${metadata.activeWidgetId[0]} .dhp-widget-inner`).innerHTML = elem.innerHTML;

      // add pheudo elem in editor
      const parent = document.getElementById(metadata.activeBlockId);
      const pheudoElem = document.createElement("div");
      pheudoElem.id = "pheudoElem";
      pheudoElem.style.width = document.querySelector(`#${metadata.activeWidgetId[0]} .dhp-widget-inner`).style.width;
      pheudoElem.innerHTML = htmlString;
      parent.appendChild(pheudoElem);

      setTimeout(() => {
        let offsetHeight = document.querySelector("#pheudoElem .timeLine_editor")?.offsetHeight;
        let offsetWidth = parseFloat(
          document.querySelector(`#${metadata.activeWidgetId[0]} .dhp-widget-inner`).style.width
        );
        let scale = parseFloat(
          document.querySelector(`#${metadata.activeWidgetId[0]} .dhp-widget-inner`).style.transform.split("(")[1]
        );
        document.querySelector("#pheudoElem").remove();
        document.querySelector(`#${metadata.activeWidgetId[0]} .dhp-widget-inner`).style.width = `${offsetWidth}px`;
        document.querySelector(`#${metadata.activeWidgetId[0]} .dhp-widget-inner`).style.height = `${offsetHeight}px`;
        document.querySelector(`#${metadata.activeWidgetId[0]} .dhp-widget-inner`).style.transform = `scale(${scale})`;

        const targetWidgetIndex = widgets.findIndex(widget => widget.id === metadata.activeWidgetId[0]);

        let newArray = Object.assign([...widgets]);
        newArray = Object.assign([...newArray], {
          [targetWidgetIndex]: {
            ...newArray[targetWidgetIndex],
            data: {
              ...newArray[targetWidgetIndex].data,
              "data-table-config": jsonString,
            },
            style: {
              ...newArray[targetWidgetIndex].style,
              width: `${offsetWidth * scale}px`,
              height: `${offsetHeight * scale}px`,
            },
            innerHTML: document.getElementById(metadata.activeWidgetId[0]).innerHTML,
          },
        });
        updateWidgets(newArray);
      }, 50);

      setTimeout(() => {
        close();
      }, 100);
    }
  };

  // Below COde to create a Default record one time onload
  useEffect(() => {
    // Update table config data
    setTableConfigData(tableConfigData);
  }, []);

  useEffect(() => {
    const hasEmptyItemName = tableConfigData.sections.some(section =>
      section.items.some(item => item.data.task_name === "" || item.data.start_date === "" || item.data.end_date === "")
    );
    setDisableInsert(hasEmptyItemName);

    const result = processSectionsData(tableConfigData.sections);
    if (result) setStartEndDateInfo(result);
  }, [tableConfigData]);

  // Close pricing table modal after innserted to canvas
  useEffect(() => {
    if (getNewWidgetObject?.id && !htmlMode) close();
  }, [getNewWidgetObject]);

  return (
    <>
      {!insertHtmlMode && (
        <div className={style["table-modal-wrap"]}>
          <div className="d-flex justify-content-between modal-header">
            <h4 className={cx(style["fw-7"], style["mb-0"])}>Timeline</h4>
            <ul className={style["d-flex"]}>
              <li
                className={cx(style["custom-tooltip"], { [style["disabled"]]: !canUndo })}
                onClick={doUndo}
                disabled={!canUndo}>
                <span className={cx(style["cursor-pointer"], style["d-flex"], style["undo"])}>
                  <Icon icon="ui-undo" />
                </span>
                <div className={cx(style["custom-tooltip-content"], style["bottom"])}>Undo</div>
              </li>
              <li
                className={cx(style["custom-tooltip"], { [style["disabled"]]: !canRedo })}
                onClick={doRedo}
                disabled={!canRedo}>
                <span className={cx(style["cursor-pointer"], style["d-flex"], style["redo"])}>
                  <Icon icon="ui-redo" />
                </span>
                <div className={cx(style["custom-tooltip-content"], style["bottom"])}>Redo</div>
              </li>

              <li className={cx(style["expand-btn"], style["rounded"])} onClick={setFullScreen}>
                <Icon icon={modalFullScreen ? "ui-collapse" : "ui-expand"} />
              </li>
              <li className={cx(style["cross-modal"], style["rounded"])} onClick={close}>
                <Icon icon="ui-close" />
              </li>
            </ul>
          </div>

          <div
            className={cx(style["modal-body"], style["customScroll"], style["scroll-Y"])}
            style={{ height: getModalHeight(), maxHeight: "calc(84% - 2rem)" }}>
            {tableConfigData?.sections?.map((sectionInfo, sectionIdx) => (
              <SectionComponent
                key={sectionIdx}
                sectionInfo={sectionInfo}
                sectionIdx={sectionIdx}
                tableConfigData={tableConfigData}
                handleBlur={handleBlur}
                isEditable={isEditable}
                handleEditClick={handleEditClick}
                changeSectionName={changeSectionName}
                onKeyDownFn={onKeyDownFn}
                moveSection={moveSection}
                deleteSectionItem={deleteSectionItem}
                updateSectionValue={updateSectionValue}
                addSectionItem={addSectionItem}
                setTableConfigData={setTableConfigData}
                dateFormat={dateFormat}
              />
            ))}
            <Row className={style["justify-content-between"]}>
              <Col>
                <div className={cx(style["add-section"])}>
                  <div className={cx(style["d-flex"], style["align-items-center"])}>
                    <a
                      className={cx(style["d-flex"], style["align-items-center"], style["color-33"])}
                      data-role="add-section"
                      tabIndex={0} 
                      onClick={() => addSectionItem("section")}>
                      <Icon icon="ui-plus" additionalclass={"mr-2"} />
                      <span>Section</span>
                    </a>
                  </div>
                </div>
              </Col>
            </Row>
          </div>

          <div className={style["modal-footer"]}>
            <button
              type="button"
              onClick={insertTable}
              className={cx(style["btn"], style["btn-primary"])}
              disabled={disableInsert}>
              {!editTable ? "Insert" : "Update"}
            </button>
          </div>
        </div>
      )}

      {/* below section need to delete after insert html page design done */}
      {insertHtmlMode && (
        <Modal
          size="lg"
          showModal={insertHtmlMode}
          component={CanvasHtmlData}
          canvasConfigData={insertedHtmlData}
          setShowModal={setInsertHtmlMode}
          startEndDateInfo={startEndDateInfo}
        />
      )}
    </>
  );
};

export default Timeline;
